var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErmoeglichtHochwertigeBerflaechen = function SvgErmoeglichtHochwertigeBerflaechen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ermoeglicht_hochwertige_berflaechen_svg__Ebene_2",
    viewBox: "0 0 119.8 98.77"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Ermoeglicht_hochwertige_berflaechen_svg__cls-2{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.1px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Ermoeglicht_hochwertige_berflaechen_svg__Layer_1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.14 0c0 4.83 3.79 8.75 8.46 8.75-4.67 0-8.46 3.92-8.46 8.75 0-4.83-3.79-8.75-8.46-8.75 4.68 0 8.46-3.92 8.46-8.75ZM94.95 13.18c0 8.31 6.53 15.06 14.56 15.06-8.04 0-14.56 6.75-14.56 15.06 0-8.31-6.53-15.06-14.56-15.06 8.05 0 14.56-6.75 14.56-15.06Z",
    className: "Ermoeglicht_hochwertige_berflaechen_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.99 97.07 3.2 66.74l57.72-30.46 55.73 31.39z",
    style: {
      strokeWidth: 3,
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 10
    }
  })));
};
export default SvgErmoeglichtHochwertigeBerflaechen;